import { css } from '@emotion/react';

import { SECONDARY_FONT_FAMILY } from 'src/styles/constants';
import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    wrapper: css({
        width: '100%',
        height: '350px',
        overflowY: 'auto',
        border: `1px solid ${theme.palette.grey[600]}`,
        padding: '0px',
        marginBottom: '30px',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '40px',
        boxSizing: 'border-box',
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
            '&::-webkit-scrollbar': {
                width: '15px',
            },
            '&::-webkit-scrollbar-track': {
                borderRadius: '0 23px 23px 0',
                boxShadow: `inset 1px 0px 0px ${theme.palette.text.placeholder}`,
                margin: '10px 0',
            },
            '&::-webkit-scrollbar-thumb': {
                paddingTop: '10px',
                backgroundColor: theme.palette.text.primary,
                borderRadius: '23px',
            },
        }),

        ol: {
            listStyleType: 'none',
            counterReset: 'item',
            margin: 0,
            padding: 0,
        },

        'ol > li': {
            display: 'table',
            counterIncrement: 'item',
            marginBottom: '0.6em',
            '&::before': {
                content: 'counters(item, ".") ". "',
                display: 'table-cell',
                paddingRight: '1em',
            },
        },

        'li ol > li': {
            counterIncrement: 'item',
            '&::before': {
                content: 'counters(item, ".") " "',
            },
        },

        strong: {
            fontSize: '18px',
            fontWeight: 700,
            lineHeight: '100%',
            fontFamily: SECONDARY_FONT_FAMILY,
            letterSpacing: 0,
            textTransform: 'uppercase',
        },

        '.header': {
            fontSize: '28px',
            fontWeight: 700,
            lineHeight: '100%',
            fontFamily: SECONDARY_FONT_FAMILY,
            letterSpacing: 0,
            textTransform: 'uppercase',
        },
    }),

    wrapperDrawer: css({
        padding: '20px 0',

        ol: {
            listStyleType: 'none',
            counterReset: 'item',
            margin: 0,
            padding: 0,
        },

        'ol > li': {
            display: 'table',
            counterIncrement: 'item',
            marginBottom: '0.6em',
            '&::before': {
                content: 'counters(item, ".") ". "',
                display: 'table-cell',
                width: '3em',
            },
        },

        // Target the first li with a full number (e.g. '1.' or '2.')
        'ol > li[class$="-listItem"]': {
            '&::before': {
                width: '1.5em',
            },
        },

        'li ol > li': {
            counterIncrement: 'item',
            '&::before': {
                content: 'counters(item, ".") " "',
            },
        },
    }),
};
